<template>
  <div class="container">
    <div class="showSth" v-if="false" v-show="titleLog">
      <span class="showTitle" v-if="!taskProgressListFlag || !todoTotalFlag">查看待办事项、评分任务进度</span>
      <span class="showTitle" v-if="todoTotalFlag && taskProgressListFlag">查看待办事项</span>
      <span class="showImg" @click="showTitle">
        <img src="../../../../assets/image/fall1.png" v-show="!showContaine" alt />
        <img src="../../../../assets/image/fall1.png" v-show="showContaine" alt style="transform: rotate(180deg);" />
      </span>
      <div class="showNo" v-show="todoTotal < 10 && todoTotal > 0">{{ todoTotal }}</div>
      <div class="showNo1" v-show="todoTotal < 99 && todoTotal > 10">{{ todoTotal }}</div>
      <div class="showNo2" v-show="todoTotal > 99">{{ todoTotal }}</div>
    </div>
    <div class="container_top" v-if="false && showContaine">
      <!-- 代办事项暂时隐藏 -->
      <div class="container_top_one" v-if="allTodotals && false" @click="toProcess">
        <div class="container_top_one_left" v-show="todoTotalFlag">
          您有待办事项
          <span class="artcial">{{ todoTotal }}</span>条
        </div>
        <div class="container_top_one_left" v-show="!todoTotalFlag">您暂时没有待办事项</div>
        <div class="container_top_one_right">
          <!-- <span v-show="todoTotalFlag" @click="toProcess">去处理</span>
          <span v-show="!todoTotalFlag" @click="toProcess">查看全部</span>-->
          <span class="showAllTop" v-show="todoTotalFlag">去处理</span>
          <span class="showAllTop" v-show="!todoTotalFlag">查看全部</span>
        </div>
      </div>
      <div class="container_top_one" :style="{ 'border-bottom-left-radius': taskProgressList.length > 0 ? 0 : '4px' }">
        <div class="container_top_one_img" @click="toScoringTask">
          品质指数·评分任务进度
          <span class="showAll">全部</span>
          <!-- <span
            class="showAll"
            v-if="taskProgressList.length "
          >{{current + 1}}/{{taskProgressListTotal}}</span> -->
        </div>
      </div>
      <div class="swipeAll" v-if="taskProgressList.length && titleShowSwipe">
        <div class="container_top_two line_top1">
          <van-swipe :height="170" :autoplay="3000" @change="onChange" indicator-color="#999"
            style="width:100%!important">
            <van-swipe-item v-for="(item, index) in taskProgressList" :key="index">
              <div class="container_top_two_top">{{ item.taskName }}</div>
              <div class="container_top_two_top_two">
                <div class="container_top_two_content">
                  <span>工单</span>
                  {{ item.total }}个
                </div>
                <div class="container_top_two_content">
                  <span>已完成</span>
                  {{ item.finishedTotal }}个
                </div>
                <div class="container_top_two_content">
                  <span>进度</span>
                  {{ item.ratio }}%
                </div>
              </div>
              <!-- 进度条 -->
              <percentLine v-if="taskProgressList" :pBageText="item.finishedTotal" :pPercent="item.ratio / 100"
                :pUnit="pUnit" :pId="index"></percentLine>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>
    <div class="banner">
      <!-- 首页公告 -->
      <!-- <scroll-list :bannerList="bannerList"></scroll-list> -->
      <scroll-listFB :bannerList="bannerList" v-if="bannerList.length" />
    </div>
    <div class="abount_address">
      <div class="address">
        <div class="left" @click="selectCity" v-if="cityChangeFlag">
          <span class="city">{{ cityChange }}</span>
          <img src="../../../../assets/image/xiala.png" class="xiala" />
        </div>
        <!-- 当用户为区县的权限时，无下拉选择城市 -->
        <div class="left" v-if="!cityChangeFlag">
          <span class="city">{{ cityChange }}</span>
        </div>

        <img @click="goSearch" src="../../../../assets/image/sousuo.png" class="search" />
      </div>
    </div>
    <div class="tabs">
      <span class="tip" :class="{ 'tip_active': currentIndex === 1 }" @click="changeIndex(1)">全部数据</span>
      <span class="tip" :class="{ 'tip_active': currentIndex === 2 }" @click="changeIndex(2)">各业态数据</span>
    </div>
    <div class="content" v-if="currentIndex === 1">
      <!-- 评分情况 -->
      <div class="chart1">
        <grop-shop class="pie_chart" :formData="formData"></grop-shop>
      </div>
      <div class="chartTotal" :class="{ 'show': currentIndex === 2 }">
        <p class="about_title">诚信指数得分分布</p>
        <div class="chart2 chart2Shadow" :class="{ chart2Shadow: currentIndex === 1 }">
          <pie-chart v-if="pieOption.pieData && pieOption.pieData.length > 0" class="pie_chart"
            :pieData="pieOption.pieData" :pieTitle="pieOption.pieTitle" :n1="pieOption.n1" :n2="pieOption.n2"
            :n3="pieOption.n3" :color="pieOption.color" :subtext="'达标企业总数(家)'"></pie-chart>
          <!-- <pie-chart class="pie_chart" ></pie-chart> -->
        </div>
        <p class="about_title">细分指数得分分布</p>
        <div class="chart2">
          <since-bar style="background: #fff;" class="pie_chart chart2Box" :experience="experience" :quality="quality"
            :standard="standard"></since-bar>
        </div>
        <p class="about_title">评价计划管理</p>
        <div class="chart3">
          <evaluate-manage :cityChangeFlag="cityChangeFlag" :summaryList="summaryList"
            style="background: #fff; box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);"></evaluate-manage>
        </div>
      </div>
    </div>
    <div class="contentBox" v-if="currentIndex === 2">
      <!-- <tabs :navList="navList" class="nav"  @changeAllData="changeAllData" :isShow="isShowTab"></tabs> -->
      <!-- :class="{'item_active':isShow === index}" -->

      <div class="content1">
        <better-scroll class="nav" :scrollX="true">
          <div class="wrapper">
            <span class="item" v-for="(item, index) in navList" :key="index" :class="{ 'item_active': isShowTab === index }"
              @click="changeData(item, index)">{{ item.name }}</span>
          </div>
        </better-scroll>
      </div>

      <!-- 总数 -->
      <grop-shop class="pie_chart" :formData="formData" :grogshopTitle="grogshopTitle"></grop-shop>

      <!-- 诚信指数 -->
      <div class="chart3">
        <p class="chart3Title">诚信指数</p>
        <p v-if="radarList1 && radarList1.length > 0" class="integrityRule">
          诚信指数=规范x{{ integrityOption.specification }}+品质x{{ integrityOption.quality }}+体验x{{ integrityOption.experience }}</p>
        <div class="chart3Box">
          <since-chart class="line_bottom sinceRadiu" v-if="radarList1 && radarList1.length > 0" :radarData="radarList1"
            :scoreData="scoreData"></since-chart>

          <!-- 区县城市指数对比 -->
          <!-- <h4 class="countryIndexTitle" v-if="cityFlag">区县城市指数对比</h4> -->
          <!-- <area-chart
            class="countryIndexChart"
            v-if="cityFlag"
            :countyCompareData="countyCompareData"
          ></area-chart>-->

          <!-- 地图 -->
          <div v-if="mapShowList">
            <h4 class="countryIndexTitle" v-if="proFlag">州市诚信指数对比</h4>
            <h4 class="countryIndexTitle" v-if="cityFlag">区县诚信指数对比</h4>
            <div v-show="proFlag || cityFlag" class="mapWap line_bottom">
              <map-chart :mapList="mapData" :level="level" ref="mapCharts"></map-chart>
            </div>
          </div>

          <!-- 州市诚信指数排行 -->
          <!-- <provice-list
            v-show="proFlag"
            :proviceListData="proviceListData"
            @changeProviceListData="changeProviceListData"
          ></provice-list>-->

          <!-- 区县诚信指数排行 -->
          <!-- <area-list
            v-show="proFlag"
            :areaListData="areaListData"
            @changeGetAreaListData="changeGetAreaListData"
          ></area-list>-->
          <div class="chartTotal" :class="{ 'show': currentIndex === 2 }">
            <!-- 诚信指数 -->
            <p class="about_title" v-if="currentIndex === 1">诚信指数得分分布</p>
            <p class="about_title_item" v-if="currentIndex === 2">诚信指数得分分布</p>
            <div class="chart2">
              <pie-chart v-if="pieOption.pieData && pieOption.pieData.length > 0" class="pie_chart"
                :pieData="pieOption.pieData" :subtext="'达标企业总数(家)'"></pie-chart>
            </div>

            <!-- 细分指数 -->
            <p class="about_title" v-if="currentIndex === 1">细分指数得分分布</p>
            <p class="about_title_item line_top" v-if="currentIndex === 2">细分指数得分分布</p>
            <div class="chart2">
              <since-bar class="pie_chart" :experience="experience" :quality="quality" :standard="standard"></since-bar>
              <!-- 企业排行榜 -->
              <enter-list class="line_top enterRadiu" :EnterpriseRankingData="EnterpriseRankingData" :ind="isShowTab"
                :cityCode="cityCode" @changeEnterpriseRankingFlag="changeEnterpriseRankingFlag"></enter-list>
            </div>
          </div>
        </div>
      </div>
    </div>
    <common-picker :cols="cols" ref="commonpicker" :typeList="typeList" @getTypeValue="getCityValue"
      v-if="cityChangeFlag"></common-picker>
    <!-- <tabs :navList='navList'></tabs> -->
  </div>
</template>
<script>
import betterScroll from '../../../../components/base/betterScroll';
import commonPicker from '../../../../components/base/commonPicker';
import grogshop from '../../components/grogshop';
import pieChart from '@/components/exponentPieChart';
import sinceBar from '../../components/SinceritySubdivisionBar';
import mapChart from '@/components/integrityGeoChart';
import proviceList from '../../components/ProvinceRanking';
import areaList from '../../components/CountyRanking';
import sinceChart from '../../components/SincerityIndexRadar';
import areaChart from '../../components/areaCountry';
import enterList from '../../components/EnterpriseRanking';
import scrollList from '../../components/scrollList';
import scrollListFB from '../../components/ScrollListFB';
import percentLine from '../../components/PercentLine';
import evaluateManage from '../../components/EvaluateManage.vue'
import api from '../../../../service/modules/integrity';
import { timeType } from '../../../../utils/configJson';
import { storageGetByName } from '../../../../utils/helper';
export default {
  components: {
    // tabs,
    percentLine: percentLine,
    'better-scroll': betterScroll,
    'scroll-list': scrollList,
    'scroll-listFB': scrollListFB,
    'common-picker': commonPicker,
    'grop-shop': grogshop,
    'pie-chart': pieChart,
    'since-bar': sinceBar,
    'evaluate-manage': evaluateManage,
    'map-chart': mapChart,
    'provice-list': proviceList,
    areaList: areaList,
    'since-chart': sinceChart,
    'area-chart': areaChart,
    'enter-list': enterList
  },
  data() {
    return {
      titleShowSwipe: false, // 州市 区县普通用户才有任务进度
      current: 0, // 轮播图
      isActive: '1',
      timer: null, // 定时器
      show: false,
      titleLog: false, // 省级无任务
      grogshopTitle: '', // 各业态总数头部
      isShowTab: 0, // 各业态数据
      bannerList: [], // 首页轮播图数据
      experience: [], // 体验指数
      quality: [], // 品质指数
      standard: [], // 规范指数
      pUnit: '个',
      // 诚信指数
      integrityOption: {
        experience: 0, // 规范
        quality: 0, // 品质
        specification: 0 // 体验
      },
      showContaine: false, // 显示待办任务标题
      // 诚信指数分数
      scoreData: '',
      // 雷达图
      radarList1: [],
      pieOption: {
        showTitle: true,
        pieTitle: '企业总数',
        pieData: [],
        color: ['#36B374', '#54BE89', '#72C99D'],
        n1: '',
        n2: '',
        n3: ''
      },
      // 地图
      mapData: [],
      mapList: [],
      level: [
        { min: 51, color: 'rgba(54,179,116,1)' },
        { min: 11, max: 50, color: 'rgba(54,179,116,0.7)' },
        { min: 6, max: 10, color: 'rgba(54,179,116,0.4)' },
        { min: 0, max: 5, color: 'rgba(54,179,116,0.1)' }
      ],
      cols: 2,
      cityChangeFlag: false,
      idx: '1',
      currentIndex: 1,
      formData: {},
      EnterpriseRankingData: [], // 企业排行榜
      EnterpriseRankingFlag: false, // 企业排行榜正序倒叙
      proviceListData: [], // 州市诚信指数排行
      proviceListDataFlag: false, // 州市诚信指数排行
      navList: [],
      countyCompareData: [], // 区县诚信对比
      areaListData: [],
      areaListDataFlag: false,
      exponentDistributionData: [],
      changeCode: '',
      areaFlag: false, // 区县权限
      proFlag: false, // 省级权限
      cityFlag: false, // 州市权限

      regionCode: '', // 用户所在区域的regionCode
      cityChange: '', // 区域改变
      cityCode: '', // 区域code
      typeList: timeType, // 区域
      userInformation: {}, // 用户信息
      todoTotal: '', // 待办任务总数
      allTodotals: true, // 包含已完成的历史记录(暂定功能)
      todoTotalFlag: '',
      task: true, // 控制显示的标题
      showNo1: false,
      showNo2: false,
      showNo3: false,
      showNoFlag: false,
      taskPageList: '', // 进度任务列表
      tasktotalPage: '',
      todoList: [], // 待办任务
      taskProgressListTotal: 0, // 进度任务数量
      taskProgressListFlag: true,
      taskProgressList: [], // 任务进度列表
      regionType: '',
      mapShowList: true,
      progresIndex: '1',
      summaryList: {} //评价计划统计
    };
  },
  created() {
    var that = this;
    // 错误适配
    if (localStorage.integrityInfo && !(JSON.parse(localStorage.integrityInfo).integrityProviLeader)) {
      yyn.invokeJSB('setActionBar', { icon: 'form', title: '申请单' }, that.handleRouter)
    }

    localStorage.removeItem('title');
    that.gteUserInfo();
    that.allThis();
  },
  computed: {
    userInfo() {
      return this.$store.state.integrity.userInfo;
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.scrollingElement.scrollTop = 0
    })

    this.getstatisticsTotal();
    this.getEnterpriseRanking(); // 企业排行榜
    this.getproviceListData(); // 州市诚信排行榜
    this.getAreaListData(); // 区县诚信排行榜
    this.getDistribution(); // 诚信指数
    this.getCountyCompare(); // 区县诚信指数对比
    this.getexponentDistribution(); // 细分指数得分分部
    // this.getAverage(); // 行业平均得分
    this.getNoticeNum()
    // this.summary(); //评价计划统计
  },
  watch: {
    regionType(val) {
      if (val === 3) {
        this.mapShowList = false;
      } else {
        this.mapShowList = true;
      }
    },
    changeCode(val) {
      if (val) {
        this.getstatisticsTotal();
        this.getEnterpriseRanking(); // 企业排行榜
        this.getproviceListData(); // 州市诚信排行榜
        this.getAreaListData(); // 区县诚信排行榜
        this.getDistribution(); // 诚信指数
        this.getCountyCompare(); // 区县诚信指数对比
        this.getexponentDistribution(); // 细分指数得分分部
        this.getAverage(); // 行业平均得分
        this.summary(); //评价计划统计
      }
    },
    userInfo(val) {
      if (
        val.integrityCityGeneral === true ||
        val.integrityCountyGeneral === true
      ) {
        this.titleShowSwipe = true;
        this.progresIndex = '2';
      } else {
        this.progresIndex = '1';
      }
      this.userInformation = val;
      localStorage.integrityInfo = JSON.stringify(val);
      this.regionCode = val.regionCode;
      this.cityCode = this.regionCode;
      if (this.$store.state.integrity.userInfo.cityCode) {
        this.cityCode = this.$store.state.integrity.userInfo.cityCode;
      } else {
        this.$store.state.integrity.userInfo.cityCode = this.cityCode
      }
      // 省级权限
      if (val.integrityProviLeader) {
        // 省级用户
        this.proFlag = 1;
        this.cityFlag = 0;
        this.areaFlag = 0;
        this.titleLog = false;
        this.cols = 2;
        this.cityChangeFlag = true;
      } else if (val.integrityCityLeader || val.integrityCityGeneral) {
        // 州市管理员 2 州市普通用户 4
        this.proFlag = 0;
        this.cityFlag = 1;
        this.areaFlag = 0;
        this.titleLog = true;
        this.cols = 2;
        this.cityChangeFlag = true;
      } else if (val.integrityCountyLeader || val.integrityCountyGeneral) {
        // 区县管理员 8 区县普通用户 16
        this.proFlag = 0;
        this.cityFlag = 0;
        this.areaFlag = 1;
        this.titleLog = true;
        this.cols = 1;
        this.cityChangeFlag = false;
      }
      localStorage.setItem('cityFlag', this.cityFlag);
      localStorage.setItem('areaFlag', this.areaFlag);
      localStorage.setItem('proFlag', this.proFlag);
      this.getCity();
      this.getindustryCategory();
      this.getstatisticsTotal();
      this.getDistribution(); // 诚信指数
      this.getEnterpriseRanking(); // 企业排行榜
      // this.getproviceListData(); // 州市诚信排行榜
      // this.getAreaListData(); // 区县诚信排行榜
      this.getCountyCompare(); // 区县诚信指数对比
      this.getexponentDistribution(); // 细分指数得分分部
      // this.getAverage(); // 行业平均得分
      // this.getfinisheList(); // 已完成任务
      this.gettaskNotice(); // 系统公告
      this.getTaskPage(); // 任务列表
      this.getTaskProgress(); // 任务进度
      // this.getTodoList(); // 待办任务
      this.getTodoTotal(); // 待办任务统计
      this.summary(); //评价计划统计
    },
    cityCode(val) {
      if (val) {
        this.getstatisticsTotal();
        this.getDistribution(); // 诚信指数
        this.getEnterpriseRanking(); // 企业排行榜
        this.getproviceListData(); // 州市诚信排行榜
        this.getAreaListData(); // 区县诚信排行榜
        this.getCountyCompare(); // 区县诚信指数对比
        this.getexponentDistribution(); // 细分指数得分分部
        if (this.currentIndex == 2) {
          this.getAverage(); // 行业平均得分
          this.summary(); //评价计划统计
        }
      }
    }
  },
  methods: {
    allThis() {
      this.timer = setInterval(() => {
        this.getindustryCategory();
        this.getstatisticsTotal();
        this.gettaskNotice(); // 系统公告
        this.getTaskPage(); // 任务列表
        this.getTaskProgress(); // 任务进度
        this.getTodoTotal(); // 待办任务统计
        this.getDistribution(); // 诚信指数
        this.getEnterpriseRanking(); // 企业排行榜
        this.getproviceListData(); // 州市诚信排行榜
        this.getAreaListData(); // 区县诚信排行榜
        this.getCountyCompare(); // 区县诚信指数对比
        this.getexponentDistribution(); // 细分指数得分分部
        this.summary(); //评价计划统计
      }, 1000 * 30)
    },
    handleRouter() {
      this.$router.push({ path: '/integrity/application' });
    },
    // 拉取待办数量
    getNoticeNum() {
      this.$store.dispatch('notice/getIntegrityNum')
    },
    onChange(index) {
      this.current = index;
    },
    showTitle() {
      this.showContaine = !this.showContaine;
    },
    // 查看待办任务列表
    toProcess() {
      this.$router.push({ path: 'agencyCenter' });
    },
    // 查看评分任务列表
    toScoringTask() {
      this.$router.push({
        path: 'taskList',
        query: { progresIndex: this.progresIndex }
      });
    },
    changeSwipe(index) {
      this.idx = 1 * index + 1;
    },
    // 获取当前用户信息
    gteUserInfo() {
      this.$store.dispatch('integrity/getUser');
    },
    getindustryCategory() {
      api.industryCategory().then(res => {
        if (res.ret === 0) {
          this.navList = res.data;
        }
      });
    },
    // 获取基础数据
    getstatisticsTotal() {
      let parm = {
        regionCode: this.cityCode, // 区域code
        industryCategory: this.changeCode // 行业code
      };
      api.statisticsTotal(parm).then(res => {
        if (res.ret === 0) {
          let data = res.data;
          // this.total = 1 * data.unGraded + 1 * data.graded + 1 * data.stop;
          this.total = 1 * data.graded;
          data.total = this.total;
          data.pExponent = data.online - data.lastOnline;
          data.zExponent = data.supervision - data.lastSupervision;
          data.hExponent = data.blacklist - data.lastBlack;
          this.formData = data;
        }
      });
    },
    // changeAllData ({ item, index }) {
    //     this.isShowTab = index
    // },
    // tab组件里面传出数据修改首页数据
    changeData(item, index) {
      localStorage.setItem('title', JSON.stringify(this.navList[index]));
      this.changeCode = item.code;
      this.isShowTab = index;
      this.grogshopTitle = item.name;
    },
    changeIndex(index) {
      this.currentIndex = index;
      if (index === 1) {
        this.changeCode = '';
        this.grogshopTitle = '';
        this.industryCategory = '';
        this.isShowTab = 0;
        localStorage.removeItem('title');
      }
      if (index === 2) {
        this.changeCode = this.navList[0].code;
        this.grogshopTitle = this.navList[0].name;
        localStorage.setItem(
          'title',
          JSON.stringify({ code: this.changeCode, name: this.grogshopTitle })
        );
      }
      this.getstatisticsTotal();
      this.getDistribution(); // 诚信指数
      this.getEnterpriseRanking(); // 企业排行榜
      this.getproviceListData(); // 州市诚信排行榜
      this.getAreaListData(); // 区县诚信排行榜
      this.getCountyCompare(); // 区县诚信指数对比
      this.getexponentDistribution(); // 细分指数得分分部
      // this.getAverage(); // 行业平均得分
    },
    // 企业排行榜
    getEnterpriseRanking() {
      let parm = {
        pageIndex: 1,
        pageSize: 5,
        regionCode: this.cityCode,
        industryCategory: this.changeCode,
        asc: this.EnterpriseRankingFlag
      };
      api.enterpriseRanking(parm).then(res => {
        if (res.ret === 0) {
          if (res.data.list) {
            res.data.list.map(item => {
              if (item.score == null) {
                item.score = '待评';
              }
            });
          }
          this.EnterpriseRankingData = res.data.list;
        }
      });
    },
    // 倒叙
    changeEnterpriseRankingFlag() {
      this.EnterpriseRankingFlag = !this.EnterpriseRankingFlag;
      this.getEnterpriseRanking();
    },
    // 州市诚信排行榜
    getproviceListData() {
      let parm = {
        regionCode: this.cityCode,
        industryCategory: this.changeCode
      };
      api.citRanking(parm).then(res => {
        if (res.ret === 0) {
          this.proviceListData = res.data.list;
          let data = res.data;
          let arrList = JSON.parse(
            JSON.stringify(data.list)
              .replace(/regionName/g, 'name')
              .replace(/score/g, 'value')
          );
          let dataLength = this.mapList.length; // 初始数据
          let arrListLength = arrList.length; // 接口数据
          for (let i = 0; i < dataLength; i++) {
            for (let j = 0; j < arrListLength; j++) {
              if (arrListLength > 0) {
                if (this.mapList[i]['name'] === arrList[j]['name']) {
                  this.mapList.splice(i, 1);
                  dataLength--;
                }
              }
            }
          }
          if (this.cityCode === '530000') {
            // 省级地图数据刷新
            this.mapData = [];
            this.mapData = [...this.mapList, ...arrList];
            this.$broadcast('refreshMap', '');
          }
        }
      });
    },
    // 倒叙
    changeProviceListData() {
      this.proviceListDataFlag = !this.proviceListDataFlag;
    },
    // 区县诚信排行榜
    getAreaListData() {
      let parm = {
        regionCode: this.cityCode,
        industryCategory: this.changeCode,
        asc: this.areaListDataFlag
      };
      api.countyRanking(parm).then(res => {
        if (res.ret === 0) {
          this.areaListData = res.data.list;
        }
      });
    },
    // 倒叙
    changeGetAreaListData() {
      this.areaListDataFlag = !this.areaListDataFlag;
    },
    // 区县诚信指数对比
    getCountyCompare() {
      let parm = {
        regionCode: this.cityCode,
        industryCategory: this.changeCode
      };
      api.countyCompare(parm).then(res => {
        this.mapData = [];
        if (res.ret === 0) {
          for (let i in res.data) {
            res.data[i].city = res.data[i].regionName;
            res.data[i].mark = res.data[i].score.toFixed(2);
            this.mapData.push({
              name: res.data[i].regionName,
              value: res.data[i].score.toFixed(2)
            });
          }
          this.countyCompareData = res.data;
        }
      });
    },
    // 细分指数得分分部
    getexponentDistribution() {
      let parm = {
        regionCode: this.cityCode,
        industryCategory: this.changeCode
      };
      api.exponentDistribution(parm).then(res => {
        if (res.ret === 0) {
          this.experience = res.data.experience;
          this.quality = res.data.quality;
          this.standard = res.data.standard;
        }
      });
    },
    // 获取城市
    async getCity() {
      this.typeList = [];
      let res = await storageGetByName('cityList', { regionCode: this.regionCode })
      this.typeList = res
      if (this.$store.state.integrity.userInfo.cityName) {
        this.cityChange = this.$store.state.integrity.userInfo.cityName;
      } else {
        this.cityChange = res[0].text ? res[0].text : res[0][0].text;
        this.$store.state.integrity.userInfo.cityName = this.cityChange
      }
      // api.region({ regionCode: this.regionCode }).then(res => {
      //     if (this.$store.state.integrity.userInfo.cityName) {
      //         this.cityChange = this.$store.state.integrity.userInfo.cityName;
      //     } else {
      //         this.cityChange = res.data[0].name;
      //         this.$store.state.integrity.userInfo.cityName = this.cityChange
      //     }
      //     let data = res.data;
      //     if (res.ret === 0) {
      //         if (this.proFlag) {
      //             let dataList = data[0].children;
      //             let arr = dataList.map(({ name, code, regionType, children }) => {
      //                 return {
      //                     text: name,
      //                     value: code,
      //                     regionType,
      //                     children: children ? children.map(({ name, code, regionType }) => {
      //                         return {
      //                             text: name,
      //                             value1: code,
      //                             regionType
      //                         };
      //                     }) : []
      //                 };
      //             });
      //             let city = data.map(({ name, code, regionType }) => {
      //                 return {
      //                     text: name,
      //                     value: code,
      //                     regionType,
      //                     children: []
      //                 };
      //             });
      //             arr = city.concat(arr);
      //             for (var i = 0; i < arr.length; i++) {
      //                 if (arr[i].children) {
      //                     let cityChild = [{ text: '--', value1: '--', regionType: '' }];
      //                     let newArr = arr[i].children.concat([]);
      //                     arr[i].children = cityChild.concat(newArr);
      //                 }
      //             }
      //             this.typeList.push(arr);
      //             localStorage.citylList = JSON.stringify(this.typeList);
      //             console.log('city省级角色切换---------:',this.proFlag, '权限', this.typeList)
      //         } else if (this.cityFlag) {
      //             if (data && data.length) {
      //                 let brr = data.map(({ name, code, regionType, children }) => {
      //                     return {
      //                         text: name,
      //                         value: code,
      //                         regionType,
      //                         children: children ? children.map(({ name, code, regionType }) => {
      //                             return {
      //                                 text: name,
      //                                 value1: code,
      //                                 regionType
      //                             };
      //                         }) : []
      //                     };
      //                 });
      //                 for (var i = 0; i < brr.length; i++) {
      //                     if (brr[i].children) {
      //                         let cityChild = [
      //                             { text: '--', value1: '--', regionType: '' }
      //                         ];
      //                         let newArr = brr[i].children.concat([]);
      //                         brr[i].children = cityChild.concat(newArr);
      //                     }
      //                 }
      //                 // let brrList = data[0].children;
      //                 // let text = data[0].name;
      //                 // let value = data[0].code;
      //                 // let regionType = data[0].regionType;
      //                 // console.log(brrList, text, value, regionType)
      //                 // if (brrList) {
      //                 //   let brr = brrList.map(({ name, code, regionType }) => {
      //                 //     return {
      //                 //       text: name,
      //                 //       value: code,
      //                 //       regionType
      //                 //     };
      //                 //   });
      //                 //   brr.unshift({ text: text, value: value, regionType: regionType });
      //                 // }
      //                 this.typeList = [];
      //                 this.typeList.push(brr);
      //                 localStorage.citylList = JSON.stringify(this.typeList);
      //             }
      //             console.log('-----city市级角色切换---:',this.proFlag, '权限', this.typeList)
      //         } else if (this.areaFlag) {
      //             let crr = res.data.map(({ name, code, regionType }) => {
      //                 return {
      //                     text: name,
      //                     value: code,
      //                     regionType
      //                 };
      //             });
      //             this.typeList.push(crr);
      //             localStorage.citylList = JSON.stringify(this.typeList);
      //             console.log('------city区县角色-----: ', this.typeList)
      //         }
      //     } 
      // });
    },
    // 搜索跳转
    goSearch() {
      this.$router.push({
        path: '/integrity/select',
        query: {}
      });
    },
    // 获取城市
    selectCity() {
      this.$refs.commonpicker.showPicker();
    },
    // 切换城市
    getCityValue(value) {
      this.regionType = value[0].regionType;
      if (value && value[1] != undefined) {
        if (value[1].text === '--') {
          this.cityChange = value[0].text;
          this.cityCode = value[0].value;
        } else {
          this.cityChange = value[1].text;
          this.cityCode = value[1].value1;
        }
      } else {
        this.cityChange = value[0].text;
        this.cityCode = value[0].value;
      }
      this.$store.state.integrity.userInfo.cityCode = this.cityCode
      this.$store.state.integrity.userInfo.cityName = this.cityChange
      // localStorage.setItem('cityName', this.cityChange);
      // localStorage.setItem('cityCode', this.cityCode);
      // 通知地图切换城市
      this.$broadcast('cityValue', {
        name: this.cityChange,
        cityCode: this.cityCode
      });
      // console.log('切换城市：', this.cityChange + '-' + this.cityCode);
    },
    // 诚信指数
    getDistribution() {
      let parm = {
        regionCode: this.cityCode, // 地区
        industryCategory: this.changeCode // 行业类别
      };
      api.distribution(parm).then(res => {
        if (res.ret === 0) {
          let data = res.data;
          try {
            this.pieOption.pieData = [
              {
                ratio: (
                  (Number(data.moreNine) /
                    (Number(data.moreNine) +
                      Number(data.sevenToNine) +
                      Number(data.sixToSeven))) *
                  100
                ).toFixed(2),
                value: Number(data.moreNine) == 0 ? 0 : Number(data.moreNine),
                name: '9.5分以上'
              },
              {
                ratio: (
                  (Number(data.sevenToNine) /
                    (Number(data.moreNine) +
                      Number(data.sevenToNine) +
                      Number(data.sixToSeven))) *
                  100
                ).toFixed(2),
                value: Number(data.sevenToNine) == 0 ? 0 : Number(data.sevenToNine),
                name: '≥7分且<9.5分'
              },
              {
                ratio: (
                  (Number(data.sixToSeven) /
                    (Number(data.moreNine) +
                      Number(data.sevenToNine) +
                      Number(data.sixToSeven))) *
                  100
                ).toFixed(2),
                value: Number(data.sixToSeven) == 0 ? 0 : Number(data.sixToSeven),
                name: '≥6分且<7分'
              }
            ];
          } catch (error) {
            console.error('诚信指数百分比转换错误');
          }
        }
      });
    },
    // 行业平均得分
    getAverage() {
      let parm = {
        regionCode: this.cityCode, // 地区
        industryCategory: this.changeCode // 行业类别
      };
      api.average(parm).then(res => {
        if (res.ret === 0) {
          try {
            let data = res.data;
            this.integrityOption.experience =
              data.weightConfig.experience / 100;
            this.integrityOption.quality = data.weightConfig.quality / 100;
            this.integrityOption.specification =
              data.weightConfig.specification / 100;

            this.scoreData = (
              (data.weightConfig.experience / 100) * (data.experienceScore || 0) +
              (data.weightConfig.quality / 100) * (data.qualityScore || 0) +
              (data.weightConfig.specification / 100) * (data.standardScore || 0)
            ).toFixed(1);
            this.radarList1 = [
              {
                name: '规范指数',
                max: 10,
                value: data.standardScore ? data.standardScore.toFixed(1) : 0
              },
              {
                name: '品质指数',
                max: 10,
                value: data.qualityScore ? data.qualityScore.toFixed(1) : 0
              },
              {
                name: '体验指数',
                max: 10,
                value: data.experienceScore ? data.experienceScore.toFixed(1) : 0
              }
            ];
          } catch (error) {
            console.error('行业平均得分转换错误', 'row 736');
          }
        }
      });
    },

    // 已完成任务
    // getfinisheList () {
    //     api.finisheList().then(res => {
    //         console.log(123, res);
    //     });
    // },
    // 系统公告
    gettaskNotice() {
      api.taskNotice().then(res => {
        if (res.ret === 0) {
          this.bannerList = res.data.list;
        }
      });
    },
    // 任务列表
    getTaskPage() {
      api.taskPage().then(res => {
        if (res.ret === 0) {
          this.taskPageList = res.data.list;
          this.tasktotalPage = res.data.pageination.totalPage;
        }
      });
    },
    // 评分任务进度
    getTaskProgress() {
      api.taskProgress().then(res => {
        if (res.ret === 0) {
          if (res.data && res.data.list.length > 0) {
            res.data.list.map(item => {
              try {
                item.ratio = ((item.finishedTotal / item.total) * 100).toFixed(
                  2
                );
                // item.pPercent = parseFloat((item.finishedTotal / item.total).toFixed(2));
                item.pPercent = parseFloat(
                  (item.finishedTotal * 100) / (item.total * 100).toFixed(2)
                );
              } catch (error) {
                console.log('评分任务进度转换错误', 'row 769');
              }
            });
            this.taskProgressList = res.data.list;
            this.taskProgressListTotal = res.data.list.length;
            if (this.taskProgressListTotal == 0) {
              this.taskProgressListFlag = false;
            } else {
              this.taskProgressListFlag = true;
            }
          }
        }
      });
    },
    // 待办任务条数
    getTodoList() {
      api.todoList().then(res => {
        if (res.ret === 0) {
          this.todoList = res.data.list;
        }
      });
    },
    // 待办任务统计
    getTodoTotal() {
      api.todoTotal().then(res => {
        if (res.ret === 0) {
          this.todoTotal = res.data.total;
          if (this.todoTotal == 0) {
            this.todoTotalFlag = false;
            this.showContaine = false;
          } else {
            this.todoTotalFlag = true;
            this.showContaine = true;
          }
        }
      });
    },
    // 评价计划统计
    summary() {
      api.summary({
        regionCode: this.regionCode
      }).then(res => {
        console.log('summaryList', res.data)
        this.summaryList = res.data;
      })
    }
    /** 原生按钮申请单 */

  },
  updated() {
    // document.scrollingElement.scrollTop = 0
  },
  destroyed() {
    clearInterval(this.timer)
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  color: #333;
  background-color: #fbfbfb;
  padding-bottom: 24px;

  .showSth {
    height: 38px;
    position: relative;
    padding-left: 12px;
    margin-bottom: 12px;
    background: rgba(54, 179, 116, 0.1);
    padding-right: 12px;

    .showTitle {
      float: left;
      font-size: 14px;
      height: 38px;
      line-height: 38px;
      color: #36b374;
    }

    .showImg {
      float: right;
      width: 12px;
      height: 12px;
      margin-top: 13px;
    }

    .showNo {
      position: absolute;
      text-align: center;
      left: 322px;
      top: 12px;
      width: 16px;
      height: 16px;
      background-color: #ff4d4d;
      color: #ffffff;
      font-size: 12px;
      line-height: 16px;
      border-radius: 8px;
    }

    .showNo1 {
      padding: 1px 1px 0 0;
      position: absolute;
      text-align: center;
      left: 316px;
      top: 12px;
      width: 22px;
      height: 16px;
      background-color: #ff4d4d;
      color: #ffffff;
      font-size: 12px;
      line-height: 16px;
      border-radius: 8px;
    }

    .showNo2 {
      position: absolute;
      text-align: center;
      left: 310px;
      top: 12px;
      width: 28px;
      height: 16px;
      background-color: #ff4d4d;
      color: #ffffff;
      font-size: 12px;
      line-height: 16px;
      border-radius: 8px;
    }
  }

  .container_top {
    width: 100%;
    padding: 0 12px 0 12px;

    .container_top_one {
      margin-top: 16px;
      background: #f5f5f5;
      color: #333333;
      height: 48px;
      line-height: 48px;
      font-size: 14px;
      box-sizing: border-box;
      border-left: 4px solid #36b374;
      border-right: 4px solid #f5f5f5;
      border-radius: 4px;
      padding: 0 8px 0 12px;

      .artcial {
        color: #36b374;
        margin: 0 4px;
      }

      .container_top_one_left {
        float: left;
        font-weight: 500;
      }

      .container_top_one_right {
        float: right;
        padding-right: 18px;
        font-size: 12px;
        background: url("../../../../assets/image/ic_jt_ck@2x.png") no-repeat center right;
        background-size: 12px 12px;
        background-position: center right;
        color: #666666;

        .showAllTop {
          margin-top: 2px;
        }
      }

      .container_top_one_img {
        font-weight: 500;
        text-align: left;
        padding-right: 18px;
        background: url("../../../../assets/image/ic_jt_ck@2x.png") no-repeat center right;
        background-position: center right;
        background-size: 12px 12px;
      }

      .showAll {
        color: #666666;
        margin-top: 1px;
        float: right;
        font-size: 12px;
        font-weight: 400;
      }
    }

    .container_top_one:nth-child(2) {
      margin-bottom: 0;
    }

    .swipeAll {
      font-size: 12px;

      .container_top_two {
        border-radius: 0 0 3px 3px;
        padding-bottom: 10px;
        // border-top: 1px solid #ebebeb;
        background: #f5f5f5;
        padding-left: 16px;
        padding-right: 16px;

        .container_top_two_top {
          margin-top: 24px;
          width: 100%;
          line-height: 14px;
          font-size: 14px;
        }

        .container_top_two_top_two {
          // overflow: hidden;
          margin-top: 12px;
          margin-bottom: 32px;

          .container_top_two_content {
            span {
              font-size: 12px;
              font-weight: 500;
              color: rgba(102, 102, 102, 1);
            }

            float: left;
            margin-right: 24px;
          }
        }
      }
    }
  }

  .banner {
    width: 100%;
    padding: 0 12px;
    box-sizing: border-box;
  }

  .abount_address {
    width: 100%;
    padding: 0 12px;
    box-sizing: border-box;
    margin-top: 24px;

    .address {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;

      .left {
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        align-items: center;

        .city {
          font-size: 20px;
          max-width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .xiala {
          width: 6px;
          height: 4px;
          margin-left: 6px;
        }
      }

      .search {
        width: 15px;
        padding: 10px;
      }
    }
  }

  .tabs {
    // width: 100%;
    box-sizing: border-box;
    margin: 17px 12px 12px 12px;
    display: flex;
    justify-content: flex-start;
    font-size: 0;
    align-items: center;

    .tip {
      width: 86px;
      padding: 8px 0;
      display: inline-block;
      text-align: center;
      font-size: 14px;
      border: 1px solid #36b374;
      border-radius: 1px;
      color: #36b374;
    }

    span:nth-child(2) {
      margin-left: 12px;
    }

    .tip_active {
      background-color: @base-color;
      color: #fff;
    }
  }
}

.container {
  width: 100%;
  background-color: #fbfbfb;
  padding-bottom: 24px;

  .banner {
    width: 100%;
    padding: 12px 12px 0 12px;
    box-sizing: border-box;
  }

  .abount_address {
    width: 100%;
    padding: 0 12px;
    box-sizing: border-box;
    margin-top: 17px;

    .address {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;

      .left {
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        align-items: center;

        .city {
          font-size: 20px;
          font-weight: 700;
          font-size: rgb(119, 100, 100);
          max-width: 100px;
          line-height: 34px;
        }

        .xiala {
          width: 6px;
          height: 4px;
          margin-left: 6px;
        }
      }

      .search {
        width: 15px;
        height: 14px;
        padding: 10px 0 10px 10px;
      }
    }
  }

  .tip_active {
    background-color: @base-color;
    color: #fff;
  }

  // }
  .content {
    width: 100%;
    padding: 0 12px;
    box-sizing: border-box;

    .content1 {
      width: 100%;
      padding: 10px 10px 0 0;
      box-sizing: border-box;
      overflow: hidden;
      position: relative;

      .nav {
        width: 100%;
        height: 46px;

        .wrapper {
          white-space: nowrap;
          position: absolute;
          padding-right: 16px;
          height: 46px;
          display: flex;
          line-height: 46px;

          .item {
            display: inline-block;
            height: 22px;
            line-height: 22px;
            margin-right: 24px;
            font-size: 14px;
          }

          .item_active {
            border-bottom: 2px solid @base-color;
            color: @base-color;
            font-weight: 600;
          }
        }
      }
    }

    .chart1 {
      margin-top: 12px;
    }

    .chartTotal {
      width: 100%;
      border-radius: 3px;

      .about_title {
        padding-top: 22px;
        padding-left: 16px;
        font-size: 20px;
        font-weight: 700;
        padding: 24px 0 12px 0;
        color: #333333;
        line-height: 20px;
      }

      .chart2 {
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        width: 100%;
        height: 100%;

        // border-radius: 3px;
        .chart2Box {
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
          border-radius: 3px;
        }
      }
    }

    .show {
      margin-top: 0;
    }

    .chart3 {
      width: 100%;

      .chart3Title {
        font-size: 20px;
        font-weight: 700;
        color: #333;
        margin-top: 24px;
      }

      .mapWap {
        height: 240px;
        margin-top: -10px;
        border-bottom: 1px solid #eeeeee;
      }

      .countryIndexTitle {
        margin-top: -30px;
        padding-top: 6px;
        background: #fff;
        padding-left: 12px;
        font-size: 14px;
        font-weight: 700;
        line-height: 46px;
        color: #333;
      }

      .countryIndexChart {
        padding: 0 8px;
      }

      .integrityRule {
        font-size: 12px;
        color: #999999;
        margin: 8px 0 12px 0;
      }
    }
  }

  .contentBox {
    width: 100%;
    padding: 0 12px;
    box-sizing: border-box;

    .content1 {
      width: 100%;
      padding: 10px 10px 0 0;
      box-sizing: border-box;
      overflow: hidden;
      position: relative;

      .nav {
        width: 100%;
        height: 36px;

        .wrapper {
          white-space: nowrap;
          position: absolute;
          padding-right: 16px;
          height: 46px;
          display: flex;
          line-height: 46px;

          .item {
            display: inline-block;
            height: 22px;
            line-height: 22px;
            margin-right: 24px;
            font-size: 14px;
          }

          .item_active {
            border-bottom: 2px solid @base-color;
            color: @base-color;
            font-weight: 600;
          }
        }
      }
    }

    .chart1 {
      margin-top: 12px;
    }

    .chartTotal {
      width: 100%;

      // .about_title {
      //     background-color: #fbfbfb;
      //     padding-top: 22px;
      //     padding-left: 16px;
      //     font-size: 20px;
      //     font-weight: 500;
      //     padding: 24px 0 12px 0;
      //     color: #333333;
      //     line-height: 20px;
      //   }
      .about_title_item {
        background-color: #fff;
        padding: 23px 0 0 16px;
        font-size: 14px;
        font-weight: 700;
      }

      .about_title_Info {
        border-top: 1px solid #eee;
      }

      .chart2 {
        // width: 100%;
        // background-color: #fff;
        // border-radius: 3px;
      }

      .chart2Shadow {
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
      }
    }

    .chart3Box {
      height: 100%;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
      border-radius: 3px;

      .sinceRadiu {
        border-radius: 3px 3px 0 0;
      }

      .enterRadiu {
        border-radius: 0 0 3px 3px;
      }
    }

    .chart3 {
      width: 100%;

      .chart3Title {
        font-size: 20px;
        font-weight: 700;
        color: #333;
        margin-top: 24px;
      }

      .mapWap {
        height: 240px;
        background: #fff;
        margin-top: -10px;
      }

      .countryIndexTitle {
        // margin-top: -30px;
        padding-top: 6px;
        background: #fff;
        padding-left: 16px;
        font-size: 14px;
        font-weight: 700;
        line-height: 46px;
        color: #333;
      }

      .countryIndexChart {
        padding: 0 8px;
      }

      .integrityRule {
        font-size: 12px;
        color: #999999;
        margin: 8px 0 12px 0;
      }
    }
  }
}</style>

<style lang="less">.van-progress__portion {
  background: @base-color !important;

  .van-progress__pivot {
    background: @base-color !important;
  }
}

.van-swipe__indicator {
  background-color: #ddd;
}</style>
